module.exports = "https://static.wmbcdn.com/uniweb/images/a35c46a7d45fcd4350526174138a6eef.svg";